
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleActionType } from "helpers/app_router";
import { STATUS_BEGIN, STATUS_DONE } from "utils/constants/others";
import useVendorStore from "../HomePage/useVendorStore";
import { HOME_SECTION_TYPES } from "../HomePage/constants";

export default function useSideMenuTiles() {
  const outletId = window.localStorage.getItem("outlet_id");
  const sellerOutletId = Number(outletId);
  const hasValidSellerOutletId = Number.isInteger(sellerOutletId) && sellerOutletId > 0;

  const getHomePageSections = useVendorStore((state) => state.getHomePageSections);
  const homePageSections = useVendorStore((state) => state.homePageSections);
  const getHomePageSectionsStatus = useVendorStore((state) => state.getHomePageSectionsStatus);

  const navigate = useNavigate();
  const [failedIconIds, setFailedIconIds] = useState({});

  useEffect(() => {
    if (!hasValidSellerOutletId) return;

    if (
      getHomePageSectionsStatus !== STATUS_BEGIN &&
      getHomePageSectionsStatus !== STATUS_DONE
    ) {
      getHomePageSections({ seller_outlet_id: sellerOutletId });
    }
  }, [getHomePageSections, getHomePageSectionsStatus, hasValidSellerOutletId, sellerOutletId]);

  const sortedHomePageSections = [...(homePageSections || [])].sort(
    (a, b) => (a?.display_order || 0) - (b?.display_order || 0)
  );

  const iconGridSection = sortedHomePageSections.find(
    (section) => section?.type === HOME_SECTION_TYPES.iconGrid
  );

  const iconGridItems = [...(iconGridSection?.items || [])].sort(
    (a, b) => (a?.display_order || 0) - (b?.display_order || 0)
  );

  const handleSectionTileClick = (item) => {
    if (!item?.action_type) return;

    handleActionType(item.action_type, item.action_data, navigate);
  };

  const orderTiles =
    iconGridItems.length > 0
      ? iconGridItems
          .map((item) => {
            if (!item?.title) return null;
            const iconKey = item.id || item.icon_url || item.title;
            const icon =
              item.icon_url && !failedIconIds[iconKey] ? item.icon_url : "";

            const disabled = !item.action_type;

            return {
              id: item.id,
              iconKey,
              label: item.title,
              icon,
              disabled,
              onClick: disabled ? undefined : () => handleSectionTileClick(item),
            };
          })
          .filter(Boolean)
      : [];

  return { orderTiles, setFailedIconIds };
}
